import cx from 'classnames';
import { useEffect, useRef, useState } from 'react';
import useOutsideClick from '../../../../../../hook/useOutsideClick';
import { getCNAAssignmentsUnitsService } from '../../../../../../services/cna/assignments';
import { isResponseOk } from '../../../../../../utility/isResponseOk';
import './styles.scss';

const UnitSwitcher = ({ currentUnit, onSwitch }) => {
  const facilityId = currentUnit?.facility?.id;
  const currentUnitId = currentUnit?.id;
  const wrapperRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [units, setUnits] = useState([]);

  useOutsideClick(wrapperRef, () => setIsOpen(false));

  useEffect(() => {
    let isMounted = true;
    if (!facilityId) return;
    (async () => {
      const res = await getCNAAssignmentsUnitsService({ facility_id: facilityId });
      if (isMounted && isResponseOk(res) && Array.isArray(res.data)) {
        setUnits(res.data);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [facilityId]);

  // Nothing to switch to — render the unit name as plain text.
  if (units.length <= 1) {
    return <span className="unit-switcher__name">{currentUnit?.name ?? '-'}</span>;
  }

  const handleSelect = (unitId) => {
    setIsOpen(false);
    if (unitId !== currentUnitId) {
      onSwitch(unitId);
    }
  };

  return (
    <div className="unit-switcher" ref={wrapperRef}>
      <button
        type="button"
        className={cx('unit-switcher__trigger', { open: isOpen })}
        onClick={() => setIsOpen((state) => !state)}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <span className="unit-switcher__name">{currentUnit?.name ?? '-'}</span>
        <svg className="unit-switcher__chevron" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 7.5L10 12.5L15 7.5" stroke="#101828" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {isOpen && (
        <ul className="unit-switcher__dropdown" role="listbox">
          {units.map((unit) => {
            const isSelected = unit.id === currentUnitId;
            return (
              <li key={unit.id} role="option" aria-selected={isSelected}>
                <button
                  type="button"
                  className={cx('unit-switcher__option', { selected: isSelected })}
                  onClick={() => handleSelect(unit.id)}
                >
                  <span className={cx('unit-switcher__radio', { selected: isSelected })} />
                  <span className="unit-switcher__option-name">{unit.name}</span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default UnitSwitcher;
